export const RESOURCE_TYPES = {
  IMAGE: 'image',
  SOUND: 'sound',
  SVG: 'svg',
  VIDEO: 'video',
  BINARY: 'binary',
  VIDEO_AS_BINARY: 'video_as_binary',
}
